import defaults from '../../translations/en.json';

/** "Care Provider Role" -> "Care provider role" */
const toSentenceCase = (label: string): string => {
  const lower = label.trim().toLowerCase();
  if (!lower) {
    return label;
  }
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

const formatInvalidFieldMessage = (fields: string[]): string => {
  if (fields.length === 1) {
    return defaults.visitErrorInvalidField.replace(
      '{field}',
      toSentenceCase(fields[0]),
    );
  }
  return defaults.visitErrorInvalidFields.replace(
    '{fields}',
    fields.map(toSentenceCase).join(', '),
  );
};

/**
 * Prefer a user-facing message from invalid field names in a 207 reason,
 * then the API reason, then the generic create error.
 */
export const getCreateVisitErrorMessage = (res: any): string => {
  if (!res || res instanceof Response || res.code !== 207) {
    return defaults.visitError;
  }
  const reason = res.status?.[0]?.reason;
  if (!reason || typeof reason !== 'string') {
    return defaults.visitError;
  }
  const bracketMatch = /\[([^\]]+)\]/.exec(reason);
  if (bracketMatch) {
    const fields = bracketMatch[1]
      .split(',')
      .map((field) => field.trim())
      .filter(Boolean);
    if (fields.length) {
      return formatInvalidFieldMessage(fields);
    }
  }
  return reason;
};
